import type { CreateMachineRequest, MachineEntity } from "../types/machine";
import type { MachineRepository } from "../repositories/machine-repository";
import { AppError } from "../../shared/utils/error-handler";

export class MachineUseCase {
  constructor(private machineRepository: MachineRepository) {}

  async createMachine(
    routerId: number,
    request: CreateMachineRequest,
  ): Promise<MachineEntity> {
    try {
      return await this.machineRepository.createMachine(routerId, request);
    } catch (error) {
      throw new AppError(
        String(error) || "기계를 생성하지 못했습니다.",
        "MACHINE_CREATE_FAILED",
        error,
      );
    }
  }
}